import type { ReactNode } from 'react';
import { DSCard, DSIcon, DSTypography } from '@eiv2/design-system';
import { IconTooltipButton } from './IconTooltipButton';
import { useFiltersPanelExpanded } from '../hooks/useFiltersPanelExpanded';

export interface CollapsibleFiltersCardProps {
  /** Chave estável por tela (ex.: `dashboard`, `leads`). */
  storageKey: string;
  title: string;
  children: ReactNode;
  className?: string;
}

export function CollapsibleFiltersCard({
  storageKey,
  title,
  children,
  className
}: CollapsibleFiltersCardProps) {
  const { expanded, toggle } = useFiltersPanelExpanded(storageKey);
  const label = expanded ? 'Recolher filtros' : 'Expandir filtros';

  return (
    <DSCard
      className={[
        'flex flex-col shadow-[0_8px_32px_oklch(0.2101_0.0318_264.66_/_0.06)]',
        className
      ]
        .filter(Boolean)
        .join(' ')}
    >
      <div className="flex items-center justify-between gap-3">
        <DSTypography as="h2" className="text-[14px] font-semibold text-dark-3">
          {title}
        </DSTypography>
        <IconTooltipButton
          aria-controls={`filters-panel-${storageKey}`}
          aria-expanded={expanded}
          label={label}
          onClick={toggle}
        >
          <DSIcon
            aria-hidden
            className={`transition-transform duration-300 ease-out ${expanded ? 'rotate-180' : 'rotate-0'}`}
            name="ArrowDown2"
            size={20}
          />
        </IconTooltipButton>
      </div>

      <div
        aria-hidden={!expanded}
        className="grid transition-[grid-template-rows] duration-300 ease-out"
        id={`filters-panel-${storageKey}`}
        style={{ gridTemplateRows: expanded ? '1fr' : '0fr' }}
      >
        <div className="min-h-0 overflow-hidden">
          <div className="flex flex-col gap-6 pt-6" inert={expanded ? undefined : true}>
            {children}
          </div>
        </div>
      </div>
    </DSCard>
  );
}
